export default function(x) {
  var r = Math.exp(x);
  r = (r + 1 / r) / 2;
  return r;
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/cosh.js
// module id = lFMR
// module chunks = 0